import { DEFAULT_CURRENCY } from '@vy/types';
import type { DeepPartial } from 'react-hook-form';
import type { InvoiceFormInput } from '../create-invoice-form-types/invoice-form-input';

export const CREATE_INVOICE_DEFAULT_VALUES: DeepPartial<InvoiceFormInput> = {
  fixedProducts: [],
  usageProducts: [],
  credits: [],
  settings: {
    currency: DEFAULT_CURRENCY,
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString(),
    paymentDueDays: 0,
  },
};

export function getDefaultValuesOfInvoiceForm(customerId?: string): DeepPartial<InvoiceFormInput> {
  return {
    ...CREATE_INVOICE_DEFAULT_VALUES,
    settings: {
      ...CREATE_INVOICE_DEFAULT_VALUES.settings,
      customerId,
    },
  };
}
